export default "__VITE_ASSET__DqMFjVNb__"